module.exports = __webpack_public_path__ + "static/media/roboto-cyrillic-ext-400-normal.4743c758.woff2";